import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ApiHelper, { BaseApiUrl } from "../../../Helpers/ApiHelper";
import { AnsweringApplicationApiUrls } from "../API/AnsweringApplicationAPI";
import { GetValueByKey, warningFlagTypeEnum } from "../../../Helpers/EnumHelper";
import { EnterFullscreen } from "../../../Helpers/FullscreenHelper";
import CautionModal from "./CautionModals/CautionModal";

const AnsweringPageWrapper = ({ children, preventCheating }) => {
  const user = useSelector((state) => state.auth.user);
  const sessionId = useSelector((state) => state.answeringApplication.sessionId);
  const sessionIdRef = useRef(null);
  sessionIdRef.current = sessionId;

  const [isFullscreen, setIsFullscreen] = useState(true);
  const [isPageVisible, setIsPageVisible] = useState(false);
  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  const [pageVisibilityWarning, setPageVisibilityWarning] = useState(false);
  const [tabSwitchWarning, setTabSwitchWarning] = useState(false);
  const [mouseOutWarning, setMouseOutWarning] = useState(false);
  const [extraScreens, setExtraScreens] = useState(false);
  const [pageBlur, setPageBlur] = useState(false);

  const [warningObject, setWarningObject] = useState({});
  const [isWarningShown, setIsWarningShown] = useState(false);

  useEffect(() => {
    setIsWarningShown(Object.values(warningObject).some((value) => value === true));
  }, [warningObject]);

  useEffect(() => {
    if (preventCheating) {
      const flagObject = {
        fullscreen: !isFullscreen,
        tabSwitch: tabSwitchWarning,
        mouseOut: mouseOutWarning,
        pageVisibility: pageVisibilityWarning,
        extraScreen: false,
        pageBlur: pageBlur,
      };

      setWarningObject(flagObject);

      sendFlagsToBackend(flagObject);
    }
  }, [isFullscreen, tabSwitchWarning, mouseOutWarning, pageVisibilityWarning, extraScreens, pageBlur]);

  const sendFlagsToBackend = (flagObject) => {
    const warningList = Object.entries(flagObject)
      .filter(([key, value]) => value)
      .map(([key]) => key);

    const warningEnumList = warningList.map((warningName) => {
      return GetValueByKey(warningName, warningFlagTypeEnum);
    });

    if (warningEnumList.length > 0) {
      const flagGetObject = {
        sessionId: sessionId,
        flagTypeEnumListJson: JSON.stringify(warningEnumList),
      };

      ApiHelper.getAsync(
        "ticket/AddFlag",
        flagGetObject,
        function (result) {
          console.log(warningEnumList);
          console.log("flags sent");
        },
        user.token
      );
    }
  };

  useEffect(() => {
    if (tabSwitchCount > 0) setTabSwitchWarning(true);
  }, [tabSwitchCount]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsPageVisible(!document.hidden);
      if (document.hidden) {
        setTabSwitchCount((prevState) => prevState + 1);
        setPageVisibilityWarning(true);
      }
    };

    const checkFullscreenStatus = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };

    const handleBeforeUnload = (event) => {
      // Standard message for confirmation dialogs

      const beaconObj = {
        id: sessionIdRef.current,
      };

      if (sessionIdRef.current) {
        //todo: testing
        navigator.sendBeacon(BaseApiUrl + AnsweringApplicationApiUrls.finishSession, beaconObj); // to reliably send the data while page is closing
      }

      return sessionIdRef.current; // This part triggers the browser alert
    };
    const handleMouseOut = (event) => {
      // Check if the user is exiting the viewport
      if (
        event.clientY <= 0 || // Moving out of the top edge
        event.clientX <= 0 || // Moving out of the left edge
        event.clientX >= window.innerWidth || // Moving out of the right edge
        event.clientY >= window.innerHeight // Moving out of the bottom edge
      ) {
        setMouseOutWarning(true);
      }
    };

    const HandlePageBlur = () => {
      setPageBlur(true);
    };

    const handleKeyDown = (event) => {
      // Detect F11 keypress (keyCode 122 or "F11")
      if (event.key === "F11" || event.keyCode === 122) {
        event.preventDefault(); // Prevent default F11 browser behavior
        EnterFullscreen();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("fullscreenchange", checkFullscreenStatus); // Detect F11
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("mouseout", handleMouseOut);
    window.addEventListener("blur", HandlePageBlur);

    checkFullscreenStatus(); //initial check
    handleVisibilityChange();

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("fullscreenchange", checkFullscreenStatus); // Detect F11
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("mouseout", handleMouseOut);
      window.removeEventListener("blur", HandlePageBlur);
    };
  }, []);

  useEffect(() => {
    // Initial detection
    detectExtraScreens();

    // Poll every 1 second
    const interval = setInterval(detectExtraScreens, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const detectExtraScreens = () => {
    setExtraScreens(window.screen.isExtended);
  };

  const handleDismiss = () => {
    EnterFullscreen();
    setTabSwitchWarning(false);
    setMouseOutWarning(false);
    setPageVisibilityWarning(false);
    setPageBlur(false);
  };

  return (
    <>
      {preventCheating && (
        <CautionModal
          isShown={isWarningShown}
          warningObject={warningObject}
          handleDismiss={handleDismiss}
          extraScreens={extraScreens}
        ></CautionModal>
      )}
      {children}
    </>
  );
};
export default AnsweringPageWrapper;
